<template>
  <div>
    <div class="complaintItem" v-for="(row, index) in list" :key="index">
      <div
        class="toptitle row flex-center"
        :class="!row.isOpen ? 'nb' : ''"
        @click="openCLoseFollow(row, index)"
      >
        <i class="iconfont icon-sanjiao" :class="row.isOpen ? 'open' : ''"></i>
        <div class="flex-1 ml4">
          <span>{{ row.complaintTime }}</span>
        </div>
        <div class="typeTag" :style="tagColor(row)">{{ row.statusText }}</div>
      </div>

      <div class="info" v-if="row.isOpen">
        <template v-if="row.isReady">
          <div class="infoitem row">
            <div class="left">登记人：</div>
            <div class="flex-1 righttext">{{ row.createEmployeeName }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">被投诉门店：</div>
            <div class="flex-1 righttext">{{ row.complaintClinicName }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">相关人：</div>
            <div class="flex-1 righttext">{{ row.complaintEmployeeName }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">事件分级：</div>
            <div class="flex-1 righttext">{{ row.eventClassification }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">事件类型：</div>
            <div class="flex-1 righttext">
              {{ row.firstEventType + "-" + row.secondEventType }}
            </div>
          </div>

          <div class="infoitem row">
            <div class="left">投诉方式：</div>
            <div class="flex-1 righttext">{{ row.complaintMode }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">计划处理员工：</div>
            <div class="flex-1 righttext">{{ row.planEmployeeName }}</div>
          </div>

          <div class="infoitem row">
            <div class="left">投诉内容：</div>
            <div class="flex-1 righttext">{{ row.complaintContent }}</div>
          </div>

          <template v-if="row.status > 0">
            <div class="infoitem row">
              <div class="left">受理时间：</div>
              <div class="flex-1 righttext">
                {{ row.acceptTime }}
              </div>
            </div>
            <div class="infoitem row">
              <div class="left">受理说明：</div>
              <div class="flex-1 righttext">{{ row.acceptRemark }}</div>
            </div>
          </template>

          <template v-if="row.status > 1">
            <div class="infoitem row">
              <div class="left">处理时间：</div>
              <div class="flex-1 righttext">
                {{ row.handleTime }} {{ row.handleEmployeeName }}
              </div>
            </div>
            <div class="infoitem row">
              <div class="left">处理过程说明：</div>
              <div class="flex-1 righttext">{{ row.handleContent }}</div>
            </div>
          </template>

          <template v-if="row.status > 2">
            <div class="infoitem row">
              <div class="left">反馈内容：</div>
              <div class="flex-1 righttext">{{ row.feedbackContent }}</div>
            </div>
          </template>
        </template>
        <div v-else v-loading="true" style="height: 100px"></div>
      </div>
    </div>

    <EmptyImgh5 v-if="list.length == 0"></EmptyImgh5>
  </div>
</template>

<script>
import { patientAdverseEvents, adverseEventsDetail } from "@/api/patient.js";
import { userStore } from "@/store/user.js";
import ImageList from "@/components/personalCenter/imageList.vue";

export default {
  name: "AdverseEvent",
  props: [],
  components: {
    ImageList,
  },
  data() {
    return {
      list: [],
    };
  },
  setup() {
    // Any setup logic here
  },
  mounted() {
    const that = this;
    //请求列表
    that.getList().then((list) => {
      //获取第一项详情
      if (list.length) {
        that.list[0].isOpen = true;
        that.getDetail(0);
      }
    });
    // Code to run after the component is mounted
  },
  methods: {
    // Your methods here
    tagColor(row) {
      const statusColors = [
        { backgroundColor: "#fff7e8", color: "#fa8c16" },
        { backgroundColor: "#e8f4ff", color: "#02a7f0" },
        { backgroundColor: "#eef9e8", color: "#039d12" },
        { backgroundColor: "#eaf8f9", color: "#28b8c3" },
      ];
      return statusColors[row.status];
    },
    openCLoseFollow(row, index) {
      const that = this;
      row.isOpen = !row.isOpen;
      //第一次加载
      if (!row.isReady) {
        that.getDetail(index);
      }
    },
    getList() {
      const that = this;
      return new Promise((resolve, reject) => {
        const aloginStoreuth = userStore();
        patientAdverseEvents({
          corpId: aloginStoreuth.corpId,
          cusId: aloginStoreuth.cusId,
        }).then((res) => {
          //已忽略不展示
          let data = (res.data.data || [])
            .map((item) => {
              item.isOpen = false;
              item.isReady = false;
              return item;
            })
            .filter((item) => item.status !== 4);
          that.list = data;
          resolve(data);
        });
      });
    },
    getDetail(index) {
      const that = this;
      const item = that.list[index];
      const { id } = item;
      adverseEventsDetail({
        id,
      }).then((res) => {
        const { data } = res.data;
        that.list[index] = {
          ...item,
          ...data,
          isReady: true,
          complaintTime: item.complaintTime, //item的不带时分
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.complaintItem {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  margin-bottom: 0.208rem;
  text-align: left;

  .time {
    margin-top: 0.25rem;
    font-size: 0.25rem;
    color: #666;
  }
}

.toptitle {
  text-align: left;
  font-size: 0.292rem;
  padding: 0.167rem 0.313rem;
  border-bottom: 1px solid #ededed;
  background: var(--unnamed, #f7f7f7);

  &.nb {
    border-bottom: none;
  }

  .icon-sanjiao {
    color: #999999;
    margin-right: 0.104rem;
    display: inline-block;
    position: relative;
    transition: all 0.3s;
    transform: rotate(-90deg);

    &.open {
      transform: rotate(0deg);
    }
  }

  .typeTag {
    font-size: 0.25rem;
    color: #333;
    background-color: #fadb14;
    padding: 0.083rem 0.125rem;
    border-radius: 0.042rem;
  }
}

.info {
  padding: 0 0.25rem 0.25rem;

  .infoitem {
    font-size: 0.292rem;
    margin-top: 0.25rem;
    text-align: left;

    .left {
      width: 2.083rem;
      color: #666;
    }

    .righttext {
      font-size: 0.292rem;
      color: #333;

      .tag {
        display: inline-block;
        width: 0.417rem;
        height: 0.417rem;
        border-radius: 0.042rem;
        text-align: center;
        font-size: 0.25rem;
        line-height: 0.417rem;
      }

      .tag.InitialDiagnosis {
        background-color: #52c41a;
        color: #fff;
      }

      .tag.FollowUpVisits {
        background-color: rgb(255, 153, 64);
        color: #fff;
      }
    }
  }
}
</style>
